






















































































import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { FormItem, Input, Option, Select } from 'element-ui';
import {
  CargoTypeEnum,
  InquiryFields,
  InquiryInput,
  ShipmentFields
} from '@/types/graphql/schemaTypes';

// Select options
import { cargoInsuranceOptions } from '@/constants/cargoInsuranceOptions';
import { customsHandlingOptions } from '@/constants/customsHandlingOptions';

@Component({
  components: {
    'el-form-item': FormItem,
    'el-input': Input,
    'el-option': Option,
    'el-select': Select
  }
})
export default class UpsertExtra extends Vue {
  @Prop({ default: () => ({}) }) inquiry!: InquiryFields | ShipmentFields;
  @Prop({ default: CargoTypeEnum.LCL, type: String }) cargoType!: CargoTypeEnum;
  @Prop({ default: false }) readOnly!: boolean;
  @Prop() stepNumber?: number;

  readonly cargoInsuranceOptions = cargoInsuranceOptions();
  readonly customsHandlingOptions = customsHandlingOptions();

  private inquiryInput: InquiryInput = {
    cargoInsurance: null,
    customsHandling: null,
    inquiryMessage: null
  };

  public created() {
    this.inquiryInput = {
      ...this.inquiryInput,
      cargoInsurance: this.inquiry.cargoInsurance || null,
      customsHandling: this.inquiry.customsHandling || null,
      inquiryMessage: this.inquiry.inquiryMessage || null
    };
  }

  @Watch('readOnly')
  @Watch('inquiryInput', { deep: true })
  updateParent() {
    if (!this.readOnly) {
      this.$emit('extraUpdated', this.inquiryInput);
    }
  }
}
